function humanizeNumber(num: number) {
  // Check if the number is less than 1000, return it as is
  if (num < 1000) return num.toString();

  // Convert number to human-friendly format
  const suffixes = ["", "K", "M", "B", "T"];
  const i = Math.floor(Math.log10(num) / 3);
  const shortNum = (num / Math.pow(1000, i)).toFixed(1);

  return shortNum + suffixes[i];
}

function formatWithCommas(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function humanizeAndFormat(num: number) {
  const humanized = humanizeNumber(num);
  if (num < 1000) return formatWithCommas(num);
  return humanized;
}
